import Api from './api';

const LeiService = {


    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/leis/listar',
            params: params
        })
        return response
    },
    numLeis: async (params) => {
        return Api({
            method: 'get',
            url: '/leis/numleis',
            params: params
        })
    },
    buscar: (params) => {
        const response = Api.get(`/leis/buscar?${params}`)
        return response
    },
    categorias: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/leis/categorias',
            params: params
        })
        return response
    }
}

export default LeiService;